import * as React from 'react';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import DriverJobsSiteArrivalAddSwmsData from './DriverJobsSiteArrivalAddSwms';
import ConfirmPopup from './ConfirmPopup';
import { getCurrentDate } from './DateHelpers';

const win: any = window;
const Stimulsoft = win.Stimulsoft;
let timeout;

interface DriverJobsSiteArrivalSwmsProps {
    scheduleIds: number[];
    swmsOptions: GenericList[];     //dropdown with swms id and item name eg. 1 Handrail
    swmsManualItems: SwmsItem[];
    swmsChecked: number;
    vehicleId: number;
    saveDisabled: boolean;
    back(): void;
    update(swmsChecked: number): void;
    updateManualSwms(swmsManualItems: SwmsItem[]): void;
    save(): void;
}

interface DriverJobsSiteArrivalSwms {
    viewSwms: boolean;
    //showEmailSwms: boolean;
    //email: string;
    sendDisabled: boolean;
    swms: Swms[];
    swmsManualItem: SwmsItem;
    showAddSwms: boolean;
    swmsEditIndex: number;
    showDeleteSwms: boolean;
    errors: any;
}

interface SwmsItem {
    swmsId: number;
    hazard: string;
    control: string;
}

interface Swms {
    item: string;
    swmsNumber: string;
    activities: SwmsActivity[];
}

interface SwmsActivity {
    activity: string;
    hazards: SwmsHazard[];
}

interface SwmsHazard {
    rating: string;
    hazard: string;
    controls: SwmsControl[];
}

interface SwmsControl {
    rating: string;
    control: string;
    responsible: string;
}

interface GenericList {
    id: number;
    name: string;
}

export default class DriverJobsSiteArrivalSwmsData extends React.Component<DriverJobsSiteArrivalSwmsProps, DriverJobsSiteArrivalSwms> {
    constructor(props: DriverJobsSiteArrivalSwmsProps) {
        super(props);

        this.state = {
            viewSwms: false,
            //showEmailSwms: false,
            //email: "",
            sendDisabled: false,
            swms: [],
            swmsManualItem: {
                swmsId: -1,
                hazard: "",
                control: ""
            },
            showAddSwms: false,
            swmsEditIndex: -1,
            showDeleteSwms: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            this.setState({ errors: errors });
        }
        
        this.props.update(e.target.value * 1);
    }

    //handleEmailChange = (e: any) => {
    //    if (e.target.value) {
    //        var error = this.state.errors;
    //        delete error[e.target.name];
    //        this.setState({ errors: error });
    //    }

    //    this.setState({ email: e.target.value });
    //}

    viewAllSwms = () => {
        var viewSwms = !this.state.viewSwms;

        if (viewSwms && this.state.swms.length === 0) {
            this.getSwms();
        } else {
            this.setState({ viewSwms: viewSwms });
        }
    }

    async getSwms() {
        const token = await authService.getAccessToken();

        var getSwms = {
            scheduleIds: this.props.scheduleIds
        };

        axios.post('api/Job/GetSwms', getSwms, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                var swms = res.data;
                this.setState({ viewSwms: true, swms: swms });
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //DOWNLOAD SWMS
    downloadSwms = (e: any) => {
        e.preventDefault();

        if (this.state.sendDisabled) {
            return;
        }

        this.setState({ sendDisabled: true });
        this.downloadSwmsPdf();
    }

    async downloadSwmsPdf() {
        const token = await authService.getAccessToken();
        var scheduleDate = getCurrentDate();

        var scheduleSwms = {
            scheduleDate: scheduleDate,
            vehicleId: this.props.vehicleId,
            scheduleIds: this.props.scheduleIds
        };

        axios.post('api/Job/GetScheduleSwmsByScheduleIds', scheduleSwms, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var swms = res.data.reportData;
            if (swms.length > 0) {
                for (let x = 0; x < swms.length; x++) {
                    let report = new Stimulsoft.Report.StiReport();
                    let reportFile = Stimulsoft.System.IO.File.getFile("reports/" + res.data.reportFileName);
                    report.load(reportFile);

                    report.dictionary.dataStore.clear();

                    let reportData = JSON.stringify(swms[x]);
                    //Dataset created
                    let dataSet = new Stimulsoft.System.Data.DataSet("data");
                    dataSet.readJson(reportData)
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.reportName = res.data.reportName;
                    report.dictionary.connect(false);
                    report.dictionary.synchronize();

                    //add relationships between data
                    for (var i = 0; i < res.data.reportRelationships.length; i++) {
                        var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(res.data.reportRelationships[i].sourceName, res.data.reportRelationships[i].name, res.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(res.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(res.data.reportRelationships[i].childTableName), [res.data.reportRelationships[i].parentFieldName], [res.data.reportRelationships[i].childFieldName]);
                        report.dictionary.relations.add(dataRelation);
                        report.dictionary.synchronize();
                    }
                    report.render();

                    let fileName = res.data.reportName + "-" + (x + 1);

                    timeout = setTimeout(this.downloadReportToPdf, 1000, report, fileName);
                }
            }
            this.setState({ sendDisabled: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    downloadReportToPdf(report: any, fileName: string) {
        report.exportDocumentAsync(function (pdfData: any) {
            // Save data to file
            Stimulsoft.System.StiObject.saveAs(pdfData, fileName + ".pdf", "application/pdf");
        }, Stimulsoft.Report.StiExportFormat.Pdf);
    }

    //END DOWNLOAD SWMS

    //EMAIIL SWMS
    //emailSwms = (e: any) => {
    //    e.preventDefault();

    //    //this.downloadSwms(scheduleItem.scheduledDate, scheduleItem.vehicleId, this.props.jobDetails.id);
    //    //this.setState({ showEmailSwms: true, sendDisabled: false });
    //}

    //hideEmailSwms = () => {
    //    this.setState({ showEmailSwms: false, sendDisabled: false });
    //}

    //updateEmail = (updatedEmail: string) => {
    //    this.setState({ email: updatedEmail });
    //}

    //sendEmail = () => {

    //}

    
    //END EMAIL SWMS

    //ADD SWMS
    addNewSwms = (e: any) => {
        e.preventDefault();

        var newSwms = this.resetNewSwms();

        this.setState({ swmsManualItem: newSwms, showAddSwms: true, swmsEditIndex: -1 });
    }

    editSwms = (e: any, swmsIndex: number) => {
        e.preventDefault();

        var manualSwms = this.props.swmsManualItems;
        var item = manualSwms[swmsIndex];

        this.setState({ swmsManualItem: item, showAddSwms: true, swmsEditIndex: swmsIndex });
    }

    cancelAddNewSmws = () => {
        var newSwms = this.resetNewSwms();

        this.setState({ swmsManualItem: newSwms, showAddSwms: false, swmsEditIndex: -1 });
    }

    updateSwmsItem = (swmsItem: SwmsItem) => {
        this.setState({ swmsManualItem: swmsItem });
    }

    resetNewSwms = () => {
        //if there is only one swmsid then default to that 
        var swmsId = -1;
        if (this.props.swmsOptions.length === 1) {
            swmsId = this.props.swmsOptions[0].id;
        }

        var newSwms: SwmsItem = {
            swmsId: swmsId,
            hazard: "",
            control: ""
        };
        return newSwms;
    }

    saveAddNewSwms = () => {
        var manualItems = this.props.swmsManualItems;
        var item = this.state.swmsManualItem;
        var showSwms = true;

        if (this.state.swmsEditIndex < 0) {
            //adding new
            manualItems.push(item);
        } else {
            //editing
            var manualItem = manualItems[this.state.swmsEditIndex];
            manualItem = item;
            showSwms = false;
        }
        this.props.updateManualSwms(manualItems);

        //keeping the swms id the same so they can add another item
        var newSwms: SwmsItem = {
            swmsId: item.swmsId,
            hazard: "",
            control: ""
        };

        //not closing the manual swms when adding as they may want to add another one
        this.setState({ swmsManualItem: newSwms, swmsEditIndex: -1, showAddSwms: showSwms });
    }

    //END ADD SWMS

    //DELETE SWMS
    deleteSwms = (e: any, swmsIndex: number) => {
        e.preventDefault();

        this.setState({ showDeleteSwms: true, swmsEditIndex: swmsIndex });
    }

    hideDeleteSwms = () => {
        this.setState({ showDeleteSwms: false, swmsEditIndex: -1 });
    }

    saveDeleteSwms = () => {
        var manualSwms = this.props.swmsManualItems; 
        manualSwms.splice(this.state.swmsEditIndex, 1);
        this.props.updateManualSwms(manualSwms);

        this.setState({ showDeleteSwms: false, swmsEditIndex: -1 });
        toast.success("Swms Item has beend deleted");
    }
    //END DELETE SWMS

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        if (this.props.swmsChecked < 0) {
            formIsValid = false;
            errors["swmsChecked"] = "SWMS check is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        } else {
            toast.error("Check validation errors before saving!");
        }
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let buttonName = this.state.viewSwms ? "Hide SWMS" : "View SWMS";
        let addSwms = <DriverJobsSiteArrivalAddSwmsData swmsOptions={this.props.swmsOptions} swmsManualItem={this.state.swmsManualItem} saveDisabled={this.props.saveDisabled} cancel={this.cancelAddNewSmws} update={this.updateSwmsItem} save={this.saveAddNewSwms} />
        let confirmDelete = <ConfirmPopup heading="Delete SWMS Item?" text="Are you sure you want to delete this item?" hideConfirmModal={this.hideDeleteSwms} showConfirmModal={this.state.showDeleteSwms} saveConfirmModal={this.saveDeleteSwms} />
        //<button className="driverjobs-swms-view" variant="link" onClick={this.emailSwms} >Email Swms</button>

        return (
            <div>
                <div className="static-modal">
                    {confirmDelete}
                </div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className={this.state.showAddSwms ? "hidden" : ""}>
                        <div className="makeitflexspacebetween marginBottom10">
                            <h4 className="mobile-margin">SWMS Checks</h4>
                            <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                        </div>

                        <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="swmsChecked">
                            <span className="label-mobile--inline margin5">Has the site been checked according to Safe Work Methods (SWMS)?</span>
                            <input type="radio" id="yes" name="swmsChecked" value={1} checked={this.props.swmsChecked === 1} onChange={(e) => this.handleChange(e)}></input>
                            <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                            <input type="radio" id="no" name="swmsChecked" value={0} checked={this.props.swmsChecked === 0} onChange={(e) => this.handleChange(e)}></input>
                            <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                        </label>
                        <span className={this.state.errors["swmsChecked"] ? "label errors" : "hidden"}>{this.state.errors["swmsChecked"]}</span>

                        <div className="alignitemscentre marginTop10">
                            <Button className="driverjobs-swms-view" variant="link" onClick={this.viewAllSwms} >{buttonName}</Button>
                            <i className="mobile-icon-green marginLeft10 fas fa-circle-plus mobileMenuSize" onClick={(e) => this.addNewSwms(e)}></i>
                            <i className="mobile-icon-grey marginLeft30 fas fa-download mobileMenuSize" onClick={(e) => this.downloadSwms(e)}></i>
                        </div>
                        <div className={this.state.viewSwms ? "" : "hidden"}>
                            {this.state.swms.map((swms, index) =>
                                <div key={index}>
                                    <div className="makeitflexspacebetween driverjobs-swms--item">
                                        <span className="makeitbold">{swms.item}</span>
                                        <span className="driverjobs-swms-no marginLeft10">{swms.swmsNumber}</span>
                                    </div>
                                    {swms.activities.map((swmsActivity, actIndex) =>
                                        <div key={actIndex}>
                                            <div className="driverjobs-swms--activity marginTop10">{swmsActivity.activity}</div>

                                            {swmsActivity.hazards.map((swmsHazard, hazIndex) =>
                                                <div key={hazIndex}>
                                                    <div className="makeitflex driverjobs-swms-back--red">
                                                        <span className="marginRight20 paddingLeft5">{swmsHazard.rating}</span>
                                                        <span className="">{swmsHazard.hazard}</span>
                                                    </div>

                                                    {swmsHazard.controls.map((swmsControl, conIndex) =>
                                                        <div key={conIndex}>
                                                            <div className="makeitflex driverjobs-swms-back--green">
                                                                <span className="marginRight20 paddingLeft5">{swmsControl.rating}</span>
                                                                <span className="">{swmsControl.control}</span>
                                                            </div>
                                                            <div className="truckcheck-background paddingLeft20">{swmsControl.responsible}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className={this.props.swmsManualItems.length === 0 ? "hidden" : "marginTop10"}>
                            <div>Additional SWMS</div>
                            {this.props.swmsManualItems.map((item, index) =>
                                <div key={index} className="manualSwmsRow paddingFull10 driverjobs-swms--delete-parent">
                                    <i className="makeitred driverjobs-swms--delete fas fa-circle-xmark" onClick={(e) => this.deleteSwms(e, index)}></i>
                                    <i className="driverjobs-swms--edit fas fa-square-pen" onClick={(e) => this.editSwms(e, index)}></i>
                                    <div className="driverjobs-swms-back--red paddingFull10">{item.hazard}</div>
                                    <div className="driverjobs-swms-back--green paddingFull10">{item.control}</div>
                                </div>
                            )}
                        </div>
                        <div className="defaultbutton__container--right marginTop10">
                            <i className="mobile-icon-green fas fa-circle-check mobileMenuSize" onClick={(e) => this.save(e)}></i>
                        </div>
                    </div>
                    <div className={this.state.showAddSwms ? "" : "hidden"}>
                        {addSwms}
                    </div>
                </div>
            </div>
        );

    }
}
